var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"administration_view"}},[_c('h1',{staticClass:"title",attrs:{"tabindex":"-1"}},[_vm._v("Gérer les notifications")]),_c('Notifications'),_c('DuplicatesAdmin'),_c('SendApplicationStatusAdmin'),_c('CustomEmailModels'),_c('Stakeholders'),_c('CleaningApplications'),_c('EmailTracking'),_c('TalentApplyAdmin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }